import { Component, Input } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { environment } from '../../../../environments/environment';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { ContentAnimDirective } from '../../product-layout/content-anim.directive';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { DefaultClassDirective } from '../../../flex-layout/class';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { LazyImgDirective } from '../../../shared/utils/directive/lazy-img.directive';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';
import { NgClass, NgOptimizedImage, NgStyle } from '@angular/common';

@Component({
  selector: 'calsoft-banner-over-content',
  imports: [ NgClass, NgStyle, CarouselModule, DefaultStyleDirective, ContentAnimDirective, DefaultLayoutDirective, DefaultLayoutAlignDirective, DefaultClassDirective, DefaultFlexDirective, LazyImgDirective, EditorTextComponent,NgOptimizedImageComponent],
  templateUrl: './banner-over-content.component.html',
  styleUrl: './banner-over-content.component.scss'
})
export class BannerOverContentComponent {
  public serverPath = environment.commonImageApi + '/commonSlider/';

  public serverPath1 = environment.commonImageApi + '/home/';

  @Input() item: any;

  @Input() img: any;

  @Input() data: any;

  customField19:any='fadeInRightShorter';

  customField21:any;

  customField15: any = 'fadeInRightShorter';

  customField30:any='white';

 introSlider = {
    ...sliderOpt,
    nav: true, 
    navText: ['<i class="icon-angle-left"></i>', '<i class="icon-angle-right"></i>'],
    loop: false,
    responsive: {
        992: {
            nav: true
        }
    }
}

constructor(  private commonService: CommonService) { }

  ngOnInit(): void {

if (this.customField19 === null || this.customField19 === undefined ) {
  this.customField19 = 'fadeInRightShorter';
}

if (this.customField21 === null || this.customField21 === undefined ) {
  this.customField21 = 'fadeInRightShorter';
}

if (this.customField15 === null || this.customField15 === undefined ) {
  this.customField15 = 'fadeInRightShorter';
}

  }

 
  link(url:any) {

    window.open(url, '_blank');
  }
  

  goToCategories(id: any) {
    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  goToCategory(menu :any) {
    this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);

  }

  
  imageNavigation(id :any){

    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  catId:any;

}

export const sliderOpt = {
  items: 1,
  loop: true,
  margin: 0,
  responsiveClass: true,
  nav: true,
  navText: ['<i class="icon-angle-left"></i>', '<i class="icon-angle-right"></i>'],
  dots: false,
  smartSpeed: 400,
  autoplay: false,
  autoplayTimeout: 15000
}